// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"456":"b5a2dda4d9cd7fe5","665":"b4aebdc0979509bd"}[chunkId] + ".js";
};